module.exports = __webpack_public_path__ + "static/media/cloud-rainbow.a988e677.svg";